// Only non-sensitive UI preferences belong here; never tokens, IDs or messages.
const ALLOWED = new Set(["kandula-ai-model", "kandula-install-dismissed", "kandula-device-voice"]);
export const readPreference = (key) => {
  if (!ALLOWED.has(key)) return null;
  try { return sessionStorage.getItem(key); } catch { return null; }
};
export const savePreference = (key, value) => {
  if (!ALLOWED.has(key)) return;
  try { sessionStorage.setItem(key, value); } catch { /* In-memory UI still works when storage is disabled. */ }
};
export const removeLegacyPreferences = () => {
  try {
    Object.keys(localStorage).filter((key) => key.startsWith("kandula-ai-session") || key === "kandula-install-dismissed").forEach((key) => localStorage.removeItem(key));
  } catch { /* Storage access is optional. */ }
};